export const ZigzinDelaysTwoDay =
  'https://cf.image-farm.s.zigzag.kr/original/mkt/2025/10/23/202510231221060686_30513.png';

export const ZigzinDelayThreeDays =
  'https://cf.image-farm.s.zigzag.kr/original/mkt/2025/10/23/202510231221560747_99296.png';

export const ZigzinDelayFourDays =
  'https://cf.image-farm.s.zigzag.kr/original/mkt/2025/10/23/202510231222310804_29157.png';

export const StoreZigzinDelaysTwoDay =
  'https://cf.image-farm.s.zigzag.kr/original/mkt/2025/10/23/202510231223380602_69172.png';

export const StoreZigzinDelayThreeDays =
  'https://cf.image-farm.s.zigzag.kr/original/mkt/2025/10/23/202510231223450666_18470.png';

export const StoreZigzinDelayFourDays =
  'https://cf.image-farm.s.zigzag.kr/original/mkt/2025/10/23/202510231223530731_37193.png';
